import { jsx as _jsx } from "react/jsx-runtime";
import { Copy } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { formatDuration } from "@air/utilities";
import { memo, useCallback } from "react";
import { useCopyTextToClipboard } from "~/hooks/useCopyTextToClipboard";
export const CopyAllButton = /*#__PURE__*/ memo((param)=>{
    let { chapters } = param;
    const { copyTextToClipboard } = useCopyTextToClipboard();
    const onCopyAll = useCallback(()=>{
        const chaptersText = chapters.map((chapter)=>"".concat(chapter.title, " (").concat(formatDuration(chapter.startTime), " - ").concat(formatDuration(chapter.endTime), "): ").concat(chapter.summary)).join("\n\n");
        copyTextToClipboard({
            text: chaptersText,
            successMessage: "All chapters copied to clipboard"
        });
    }, [
        chapters,
        copyTextToClipboard
    ]);
    return /*#__PURE__*/ _jsx(Button, {
        onClick: onCopyAll,
        size: "small",
        color: "grey",
        appearance: "outline",
        prefix: /*#__PURE__*/ _jsx(Copy, {
            className: "size-3"
        }),
        children: "Copy all"
    });
});
CopyAllButton.displayName = "CopyAllButton";
